const translations = {
    address: 'Address',
    city: 'City',
    company: 'Company',
    country: 'Country: United States',
    name: 'Name',
    state: 'State',
    zipCode: 'Zip Code'
};

export default translations;
